import md5 from 'md5'

export const makeCacheKey = (anything) => {
  if(typeof anything === 'string') {
    return md5(anything)
  } 
  return md5(JSON.stringify(anything))
}

export const CACHE_KEY = {
  OWNERSHIP: 'ownership',
  MANUFACTURER: 'manufacturer',
  MFR_PROFILE: 'manufacturerProfile'
}

const initialState = {}
let cacheMap = initialState

const cacheReducer = (state, action) => {
  switch (action.type) {
    case 'set':
      return { ...state, [action.key]: action.value }
    case 'remove': {
      const newState = { ...state }
      delete newState[action.key]
      return newState
    }
    case 'removeStartingWith': {
      const newState = { ...state }
      const keysStartingWith = Object.keys(newState).filter(k => k.startsWith(action.key)) || []
      keysStartingWith.forEach(key => {
        delete newState[key]
      })
      return newState
    }
    default:
      return state
  }
}

const dispatch = ({type, key, value}) => {
  cacheMap = cacheReducer(cacheMap, {
    type,
    key,
    value
  })
}


class Cache {
  getItem = (key) => {
    if (cacheMap && Object.keys(cacheMap).includes(key)) {
      const cacheEntry = cacheMap[key]
      if (cacheEntry.expiresAt && cacheEntry.expiresAt < new Date().getTime()) {
        return null
      }
      return cacheEntry.item
    }
    return null
  }

  setItem = (key, item, ttlSeconds = undefined) => {
    const expiresAt = ttlSeconds ? new Date().getTime()+(ttlSeconds*1000) : undefined
    dispatch({type: 'set', key, value: { item, expiresAt }})
  }

  removeItem = (key) => {
    if (cacheMap) {
      dispatch({type: 'remove', key })
    }
    return null
  }

  removeAll = () => {
    if (cacheMap) {
      Object.keys(cacheMap).forEach(key => dispatch({type: 'remove', key }))
    }
    return null
  }

  removeItemsStartingWith = (key) => {
    console.log('removeItemsStartingWith', key)
    if (cacheMap) {
      dispatch({type: 'removeStartingWith', key })
    }
    return null
  }


}

const cache = new Cache()
export default cache